import React, { useEffect, useState } from 'react';

import { authService } from '../services/auth';
import { apiService } from '../services/api';
import { ProfileHeader } from '../components/ProfileHeader';
import { UserProfile } from '../types';
import './AccountPage.css';

export const AccountPage: React.FC = () => {
  const userInfo = authService.getUserInfo();
  const [profile, setProfile] = useState<UserProfile | null>(null);

  useEffect(() => {
    const fetchProfile = async () => {
      if (!userInfo?.sub) return;
      try {
        const userProfile = await apiService.getUserProfile(userInfo.sub);
        setProfile(userProfile);
      } catch (error) {
        console.error('Failed to fetch logged-in user profile:', error);
      }
    };

    fetchProfile();
  }, [userInfo?.sub]);

  const getUserDisplayName = () => {
    if (!userInfo) return 'User';

    const givenName = userInfo.given_name || userInfo.name?.split(' ')[0];
    const familyName = userInfo.family_name || userInfo.name?.split(' ').slice(1).join(' ');

    if (givenName && familyName) {
      return `${givenName} ${familyName}`;
    }

    return userInfo.name || userInfo.email?.split('@')[0] || 'User';
  };

  const handleLogout = () => {
    authService.logout();
  };

  return (
    <div className="account-page">
      <div className="account-container">
        <ProfileHeader
          profileImageUrl={userInfo?.picture}
          userName={getUserDisplayName()}
          totalPollsCreated={profile?.totalPollsCreated}
          linkTo="/activity?tab=created"
        />

        <div className="profile-info">
          {userInfo?.email && (
            <div className="info-row">
              <span className="info-label">Email</span>
              <span className="info-value">{userInfo.email}</span>
            </div>
          )}
        </div>

        <button className="logout-btn" onClick={handleLogout}>
          Logout
        </button>

        <div className="account-legal-section">
          <a href="/terms.html" className="account-legal-link">Terms of Service</a>
          <span className="bullet-separator">•</span>
          <a href="/privacy.html" className="account-legal-link">Privacy Policy</a>
        </div>
      </div>
    </div>
  );
};


